import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Text } from "@mantine/core";
import { AccessTimeOutlined, Cancel, CheckCircleOutline } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import { getRelativeTimeFromDate } from "../../utils/Date.utils";
export const PriorityInviteChip = ({ acceptedAt, declinedAt, updatedAt }) => {
    const acceptedAtDate = acceptedAt ? new Date(acceptedAt) : null;
    const declinedAtDate = declinedAt ? new Date(declinedAt) : null;
    const updatedAtDate = new Date(updatedAt);
    const time = acceptedAtDate
        ? `Accepted: ${getRelativeTimeFromDate(acceptedAtDate, true)}`
        : declinedAtDate
            ? `Declined: ${getRelativeTimeFromDate(declinedAtDate, true)}`
            : `Invited: ${getRelativeTimeFromDate(updatedAtDate, true)}`;
    const color = acceptedAtDate
        ? "var(--mantine-color-primary-9)"
        : declinedAtDate
            ? "var(--mantine-color-red-5)"
            : "var(--mantine-color-orange-5)";
    const backgroundColor = acceptedAtDate
        ? "var(--mantine-color-primary-0)"
        : declinedAtDate
            ? "color-mix(in srgb, var(--mantine-color-red-5) 5%, transparent)"
            : "color-mix(in srgb, var(--mantine-color-orange-5) 5%, transparent)";
    return (_jsxs(Flex, { gap: "xs", align: "center", style: {
            width: "fit-content",
            padding: "0.25rem 0.5rem",
            borderRadius: "1rem",
            borderStyle: "solid",
            borderColor: color,
            borderWidth: "1px",
            backgroundColor,
            lineClamp: 1
        }, children: [_jsx(SvgIcon, { component: acceptedAt
                    ? CheckCircleOutline
                    : declinedAt
                        ? Cancel
                        : AccessTimeOutlined, style: {
                    color,
                    fontSize: "1.2rem"
                } }), _jsx(Text, { variant: "body", children: time })] }));
};
